module.exports = __webpack_public_path__ + "img/banner-bruta.9d1132d2.jpg";